module.exports = __webpack_public_path__ + "img/charge_bike0.1d4796b2.png";